// Utility functions for API logic

export function getApiConfig(endpoint, params = {}) {
  const config = {
    url: endpoint.url,
    method: endpoint.method,
  };
  if (endpoint.method.toLowerCase() === 'get') {
    config.params = params;
  } else {
    config.data = params;
  }
  return config;
}

export function formatApiError(error) {
  if (!error) return '';
  if (typeof error === 'string') return error;
  if (error.response && error.response.data) {
    // Support both JSON objects ({ message }) and plain strings
    const data = error.response.data;
    if (typeof data === 'string') return data;
    if (data.message) return data.message;
  }
  if (error.message) return error.message;
  return String(error) || 'Unknown error';
}
